import * as audio from './kernel/audio.js';
import * as dom from './dom.js';
import * as scene from './scene.js';
import * as karappo from './karappo.js';

export {
    start,
}

// Development
window.DEVMODE = true;

// Config
window.LSI = 25; // Line Sequence Interval (Used in screen.sequence and unveil
                 // calls for line by line time interval in milliseconds)

function init() {
    dom.init();
    dom.status('Initializing...');

    audio.init();

    dom.status('Loading...');

    scene.init().then(() => {
        dom.showStart();
    });
}

function start() {
    karappo.start();
}

init();
